import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://cymjsqoqnxexcefogbey.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN5bWpzcW9xbnhleGNlZm9nYmV5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg0MDExMTAsImV4cCI6MjA4Mzk3NzExMH0.HiEOWs0mHOX-knImGJmh3Oj8fcDGodY3SLQHIkviZeY'

// Debug logs para diagnóstico
console.log('🔧 Supabase Config:')
console.log('URL:', supabaseUrl)
console.log('Key:', supabaseAnonKey ? supabaseAnonKey.substring(0, 20) + '...' : 'MISSING')

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Tipos para o banco de dados
export interface SegmentoCliente {
  id: string
  nome: string
  descricao?: string
  icone?: string
  ativo: boolean
  ordem: number
  created_at: string
  updated_at: string
}

export interface Cliente {
  id: string
  nome_completo: string
  celular: string
  data_nascimento?: string
  razao_social?: string
  nome_empresa?: string
  data_inauguracao?: string
  cnpj?: string
  telefone?: string
  email?: string
  endereco?: string
  quantos_colaboradores?: string
  faturamento_empresa?: string
  faturamento_desejado?: string
  site?: string
  instagram?: string
  facebook?: string
  whatsapp_anuncios?: string
  cidades_anunciar?: string
  bairros_anunciar?: string
  publico_ideal?: string
  informacoes_adicionais_anuncios?: string
  responsavel_financeiro?: string
  email_financeiro?: string
  telefone_financeiro?: string
  observacoes?: string
  segmento_id?: string
  segmento?: SegmentoCliente
  status: 'ativo' | 'inativo'
  data_cadastro: string
  data_atualizacao: string
  data_inativacao?: string
  created_at: string
  updated_at: string
}

export interface UsuarioGestao {
  id: string
  email: string
  nome: string
  role: 'admin' | 'gestor' | 'viewer'
  ativo: boolean
  ultimo_acesso?: string
  created_at: string
  updated_at: string
}

export interface MonthlyDataPoint {
  mes: string
  mesCompleto: string
  quantidade: number
  mesAnterior: number
  diferenca: number
  variacao: number
  tipo: 'aumento' | 'reducao' | 'neutro'
}

export interface ComparacaoMensal {
  mesAtual: {
    quantidade: number
    mes: string
  }
  mesAnterior: {
    quantidade: number
    mes: string
  }
  diferenca: number
  variacaoPercentual: number
  tipo: 'aumento' | 'reducao'
  historicoMensal: MonthlyDataPoint[]
}

export interface DashboardMetrics {
  totalClientes: number
  clientesAtivos: number
  clientesInativos: number
  novosClientesHoje: number
  novosClientesSemana: number
  novosClientesMes: number
  crescimentoPercentual: number
  comparacaoPeriodoAnterior: {
    periodo: string
    variacao: number
    tipo: 'aumento' | 'reducao'
  }
  comparacaoMensal?: ComparacaoMensal
}

export interface ClienteNotaAnexo {
  id: string
  nota_id: string
  nome_arquivo: string
  tipo_arquivo: string
  tamanho_arquivo: number
  url_arquivo: string
  created_at: string
}

export interface ClienteNota {
  id: string
  cliente_id: string
  titulo: string
  conteudo: string
  tipo_nota: 'geral' | 'importante' | 'lembrete' | 'comercial' | 'financeiro'
  usuario_id: string
  usuario_nome: string
  created_at: string
  updated_at: string
  anexos?: ClienteNotaAnexo[]
}
